export const NAV = {
  brand: "nav-brand",
  linkServices: "nav-services-link",
  linkAbout: "nav-about-link",
  linkContact: "nav-contact-link",
  ctaBook: "nav-cta-btn",
  langSwitcher: "nav-lang-switcher",
  langOption: (code) => `nav-lang-option-${code}`,
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
};

export const SERVICES = {
  section: "services-section",
  card: (key) => `service-card-${key}`,
};

export const ABOUT = {
  section: "about-section",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  phone: "contact-input-phone",
  subject: "contact-input-subject",
  message: "contact-input-message",
  submit: "contact-submit-btn",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  section: "footer-section",
};
